<template>
    <div class="solicitud">
        <h2 class="text-center" v-text="campos.titulo"></h2>
        

        <form action="">
            <button type="button" class="d-none btn btn-primary text-white"  @click.prevent="test_referer()">Test referer</button>

            <transition-group name="fieldset-transition">
            </transition-group>

            <fieldset v-if="modo=='inicio'" key="inicio">
                <div class="text-center py-3">
                    
                    <a href="#" @click.prevent="toggle_cliente(false)" :class="{'btn-cliente': true, 'activo': campos.es_cliente===false}">Aún no soy cliente</a>
                    <a href="#" @click.prevent="toggle_cliente(true)" :class="{'btn-cliente': true, 'activo': campos.es_cliente===true}">Sí, soy cliente de BAS</a>
                </div>
            </fieldset>



            <fieldset v-if="modo=='verificacion'" key="verificacion">
                <h6>Por favor, ingresá los siguientes datos para poder identificarlos como cliente:</h6>

                <div>
                    <label for="codcli">Código de cliente (*)</label>
                    <input type="text" id="codcli" name="codcli" maxlength="80" v-model="campos.codcli">
                </div>

                <div>
                    <label for="cuit">CUIT (*)</label>
                    <input type="text" id="cuit" name="cuit" maxlength="100" required v-model="campos.cuit">
                </div>
                <p>
                    <button type="button" class="boton" :disabled="!habilitado" @click.prevent="verificar_cliente()">
                        Siguiente <i class="fas fa-spinner" v-if="!habilitado" ></i>
                    </button>
                </p>
                <BtnVolver @click="home" />
            </fieldset>



            <fieldset v-if="modo==='formulario'" key="formulario">
                <div class="d-none">
                    <a href="#" @click.prevent="cambiar_pack('pack1')" :class="{'btn-pack': true, activo:campos.pack=='pack1'}">PACK 1</a>
                    <a href="#" @click.prevent="cambiar_pack('pack2')" :class="{'btn-pack': true, activo:campos.pack=='pack2'}">PACK 3</a>
                    <a href="#" @click.prevent="cambiar_pack('pack3')" :class="{'btn-pack': true, activo:campos.pack=='pack3'}">PACK 5</a>
                </div>
                
                <h4 class="pack-seleccionado">Seleccionaste el {{campos.pack}} con acceso a {{campos.sistema}}</h4>
                    
                <h6>Por favor, completá los siguientes datos. Los marcados con (*) son obligatorios:</h6>

                <div v-if="debe_indicar_cantidad && campos.tipo=='software'">
                    <label for="cantidad">Cantidad de Licencias (cantidad de packs)</label>
                    <div class="row-corta">
                        <input name="cantidad" id="cantidad" type="number" min="1" max="50" v-model="campos.cantidad" @input="rango_cantidad">
                        <input type="hidden" name="adicionales" v-model="campos.quiere_adicionales">
                    </div>
                </div>

                <div v-if="parametros.pack == 'Pack 5'">
                    
                    <!-- <label>Cantidad de {{campos.adicionales_tipo}}</label> -->
                    <div><input type="checkbox" v-model="campos.quiere_adicionales" @click="campos.adicionales=''"> 
                        <span class="adicionales">Quiero agregar {{campos.adicionales_tipo}} a los incluidos en el Pack</span></div>

                    <div class="row-corta">
                        <input name="adicionales" id="adicionales" maxlength="2" type="number" min="1" max="15" 
                        v-model="campos.adicionales" v-show="campos.quiere_adicionales" :class="{desactivado: !campos.quiere_adicionales, activado:campos.quiere_adicionales}" >
                        
                    </div>
                </div>

                <br>


                <h4>Datos de facturación</h4>
                <div>
                    <label for="razon_social">Titular (Razón Social / Apellido y Nombre) (*)</label>
                    <input name="razon_social" id="razon_social" maxlength="80" type="text" required v-model="campos.razon_social">
                </div>

                <div>
                    <label for="documento">Tipo de Documento</label>
                    <select name="documento" id="documento" v-model="campos.tipo_documento">
                        <option value="dni">DNI</option>
                        <option value="cuit">CUIT</option>
                    </select>
                    <label for="cuit">Número {{campos.tipo_documento.toUpperCase()}} (*)</label>
                    <input name="cuit" maxlength="100" type="text" required v-model="campos.cuit">
                </div>

                <div>
                    <label for="domicilio">Domicilio Legal - Calle, Nro, Localidad y Provincia (*)</label>
                    <input name="domicilio" id="domicilio" maxlength="80" type="text" required v-model="campos.domicilio">
                </div>

                <div style="display: none;">
                    <label for="iibb">N° Ingresos Brutos</label>
                    <input name="iibb" id="iibb" maxlength="100" type="text" v-model="campos.iibb">
                </div>

                <br>


                <h4>Datos del solicitante</h4>
                <div>
                    <label for="nombre">Nombre (*)</label>
                    <input name="nombre" id="nombre" maxlength="80" type="text" required v-model="campos.nombre">
                </div>

                <div>
                    <label for="apellido">Apellido (*)</label>
                    <input name="apellido" id="apellido" maxlength="80" type="text" required v-model="campos.apellido">
                </div>

                <div>
                    <label for="mail">Email (*)</label>
                    <input name="mail" id="mail" maxlength="100" type="email" required v-model="campos.email">
                </div>

                <div>
                    <label for="telefono">Teléfono (*) (Ej: 011 4444-1111)</label>
                    <input name="telefono" id="telefono" maxlength="30" type="tel" required v-model="campos.telefono">
                </div>

                <div>
                    <label for="dni">DNI (*)</label>
                    <input name="dni" id="dni" maxlength="30" type="text" required v-model="campos.dni">
                </div>

                <div>
                    <label for="cargo">Cargo (*)</label>
                    <input name="cargo" id="cargo" maxlength="50" type="text" required v-model="campos.cargo">
                </div>

                <p>
                    <button type="button" class="boton solicitud-scroll" @click.prevent="procesar_form()" :disabled="!habilitado">
                        Siguiente <i class="fas fa-spinner" v-if="!habilitado" ></i>
                    </button>
                </p>
                
                <BtnVolver @click="home" />
            </fieldset>


        
            <fieldset v-if="modo==='forma_pago'" key="forma_pago">
                <div class="text-center py-3">
                    <h6>Seleccionar forma de pago</h6>
                    <p>
                        <a href="#" @click.prevent="toggle_forma_pago('PMC')" 
                            :class="{'btn-cliente': true, 'activo': campos.forma_pago===formas_pago.PMC}">{{formas_pago.PMC}}</a>
                    </p>
                    <p>
                        <a href="#" @click.prevent="toggle_forma_pago('AUT')" 
                            :class="{'btn-cliente': true, 'activo': campos.forma_pago===formas_pago.AUT}">{{formas_pago.AUT}}</a>
                    </p>
                    <p>
                        <a href="#" @click.prevent="toggle_forma_pago('CBU')" 
                            :class="{'btn-cliente': true, 'activo': campos.forma_pago===formas_pago.CBU}">{{formas_pago.CBU}}</a>
                    </p>
                </div>

                <div v-if="campos.forma_pago==formas_pago.AUT">
                    <h6>Completar los siguientes campos:</h6>
                    <div class="row">
                        <div class="col" style="min-width: 200px;">
                            <label>Tarjeta de crédito (*)</label>
                            
                            <p>
                                <input type="radio" name="tarjeta_tarjeta" id="visa" value="Visa" v-model="campos.tarjeta.tarjeta"> 
                                <label class="tarjeta visa" for="visa">Visa</label>
                            </p>
                            <p>
                                <input type="radio" name="tarjeta_tarjeta" id="mastercard" value="Mastercard" v-model="campos.tarjeta.tarjeta"> 
                                <label class="tarjeta master" for="mastercard">Master</label>
                            </p>
                        </div>
                        <div class="col">
                            <div>
                                <label for="tarjeta_titular">Titular (*)</label>
                                <input name="tarjeta_titular" id="tarjeta_titular" maxlength="80" type="text" required v-model="campos.tarjeta.titular">
                            </div>
                            <div>
                                <label for="tarjeta_nro">Número (*)</label>
                                <input name="tarjeta_nro" id="tarjeta_nro" maxlength="16" type="text" required v-model="campos.tarjeta.numero">
                            </div>
                            <div>
                                <label for="tarjeta_vto_mes">Vencimiento</label>
                                <div class="row">
                                    <div class="col" style="margin-right: 10px;">
                                        <select name="tarjeta_vto_mes" id="tarjeta_vto_mes" v-model="campos.tarjeta.vto_mes">
                                            <option v-for="mes in meses" :value="mes" :key="mes">{{mes}}</option>
                                        </select>
                                    </div>
                                    <div class="col">
                                        <select name="tarjeta_vto_anio" id="tarjeta_vto_anio" v-model="campos.tarjeta.vto_anio">
                                            <option v-for="anio in anios" :value="anio" :key="anio">{{anio}}</option>
                                        </select>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>

                <div v-if="campos.forma_pago==formas_pago.CBU">
                    <h6>Completar el siguiente dato:</h6>

                     <div class="row">
                        <div class="col">
                            <label for="cbu">CBU (*)</label>
                            <input name="cbu" id="cbu" maxlength="22" type="text" required v-model="campos.cbu">
                        </div>
                     </div>
                    <p><em>La titularidad de la CBU informada debe ser del cliente a quien se emite la factura.</em></p>
                </div>

                <p>
                    <button type="button" class="boton solicitud-scroll" :disabled="!forma_pago_completada" @click.prevent="verificar_forma_pago()">
                        Siguiente <i class="fas fa-spinner" v-if="!habilitado" ></i>
                    </button>
                </p>
                
                
                <BtnVolver @click="home" />
            </fieldset>



            <fieldset v-if="modo=='contrato'" key="contrato">
                <p>A continuación lea detenidamente los detalles de la Solicitud para conocer sus alcances, luego acepte las Condiciones y presione "Aceptar" para continuar.</p>

                <!-- El siguiente contenido se reemplaza con lo que devuelve via api.php -->
                <div id="contrato" v-html="contrato"></div>

                <div v-if="tiene_versiones_anteriores">
                    <p>El pack que está solicitando corresponde a la versión <strong>{{version_vigente}}</strong>.
                    Hemos detectado que Ud. tiene instalado un Dispositivo de Control de Licencia (DCL) con una versión anterior.
                    Los DCL's de versiones anteriores no son compatibles con el pack, por lo que recomendamos que los actualice.
                    Si no los actualiza, puede seguir utilizándolos en su versión en una instalación independiente a la del pack.
                    </p>
                </div>

                <p><input name="acepta_contrato" id="acepta_contrato" type="checkbox" v-model="acepta_contrato">
                    <label for="acepta_contrato">{{acepta_label}}</label>
                </p>

                <div v-if="acepta_contrato">
                    <button type="button" class="boton" :disabled="!habilitado" @click.prevent="enviar_emails()">
                        Aceptar <i class="fas fa-spinner" v-if="!habilitado" ></i>
                    </button>
                </div>

                <BtnVolver @click="home" />
            </fieldset>


            <fieldset v-if="modo=='gracias'" key="gracias">
                <p>Gracias, hemos recibido su Solicitud para ({{campos.cantidad}}) {{parametros.sistema}} {{parametros.pack}}.<br>
                    Nuestro Ejecutivo de Cuenta se pondrá en contacto con Ud. a la brevedad.</p>
                <p>Le agradecemos que haya confiado en una solución BAS para su empresa.</p>
                <p>Buenos Aires Software.</p>
                
                <BtnVolver @click="home" v-if="parametros.debug" />
            </fieldset>
            

            <div class="resultado" :class="this.resultado_modo" v-if="resultado">
                {{resultado}}
            </div>

        </form>

    </div>
</template>


<script>

    // Components
    import BtnVolver from '@/components/BtnVolver.vue';

    // Dependencies
    import jQuery from 'jquery';
    import alertify from 'alertifyjs';

    import 'alertifyjs/build/css/alertify.min.css';
    import 'alertifyjs/build/css/themes/default.min.css';
    import payform from 'payform';
    import {log, server, toUpper} from '../helpers/index.js';
import { createApp } from 'vue';

    export default {
        name: 'FormClientes',

        components: {
            BtnVolver
        },

        props: {
            parametros: Object
        },

        data() {
            return {
                modo: 'inicio',
                habilitado: true,
                resultado: null,
                resultado_modo: null,
                acepta_contrato: false,
                acepta_label: null,
                version_vigente: null,
                formas_pago: { PMC: 'Pagomiscuentas', AUT: 'Débito automático Tarjeta de Crédito', CBU: 'Débito automático Cuenta Bancaria'},            
                contrato: null, // se carga dinamicamente,
                campos: {
                    grupo: 'clientes',
                    tipo: this.parametros.tipo_licenciamiento,
                    titulo: null, // depende del tipo,
                    sistema: this.parametros.sistema,
                    rubro: this.parametros.rubro,
                    idsistema: this.parametros.idsistema,
                    pack: this.parametros.pack,
                    cantidad: 1,
                    quiere_adicionales: false, // exclusivo PACK5 
                    adicionales: "", // (int) cantidad
                    adicionales_tipo: "", //software => Accesos, saas => Usuarios
                    nombre: "",
                    apellido: "",
                    email: "",
                    telefono: "",
                    dni: "",
                    cargo: "",
                    razon_social: "",
                    tipo_documento: 'cuit',
                    cuit: "",
                    domicilio: "",
                    iibb: "",
                    es_cliente: null,
                    forma_pago: null,
                    forma_pago_cod: null,
                    cbu: null,
                    tarjeta: {
                        titular: null,
                        tarjeta: null, 
                        numero: null,
                        vto_mes: new Date().getMonth() + 1,
                        vto_anio: new Date().getFullYear()
                    },
                    versiones_instaladas: null, // es la versión del que tiene un cliente 
                    codcli: null,
                    tiene_producto: false,
                    tiene_sar: false
                }
            }
        },

        computed: {
            publicPath(){
                return process.env.BASE_URL;
            },

            imgRoot(){
                return './../assets/';
            },

            tarjeta_seleccionada(){
                return payform.parseCardType(this.campos.tarjeta.numero);
            },
            
            nro_tarjeta_valido(){            
                return payform.validateCardNumber(this.campos.tarjeta.numero);
            },

            nombre_completo(){
                return this.campos.nombre + ' ' + this.campos.apellido;
            },

            forma_pago_completada(){                
                return this.campos.forma_pago == this.formas_pago.PMC 
                        || (this.campos.forma_pago==this.formas_pago.AUT && this.campos.tarjeta.numero!=null && this.campos.tarjeta.numero.length>=14 )
                        || (this.campos.forma_pago == this.formas_pago.CBU && this.campos.cbu!=null && this.campos.cbu.length == 22);
            },

            debe_indicar_cantidad(){
                // En Pack 1 puede indicar más de 1 cantidad 
                return (this.campos.pack === 'Pack 1' )
            },

            tiene_versiones_anteriores(){
                let r = false;
                for(let i in this.campos.versiones_instaladas){
                    let v = this.campos.versiones_instaladas[i];
                    if (v != this.version_vigente){
                        r=true; 
                        break;
                    }
                }
                return r;
            },

            hoy() {
                var event = new Date();
                var options = { year: 'numeric', month: 'numeric', day: 'numeric' };
                return event.toLocaleDateString('es-ES', options);
            },

            meses(){
                return [1,2,3,4,5,6,7,8,9,10,11,12];
            }, 

            anios() {
                var currentYear = new Date().getFullYear();
                var lastYear = currentYear + 10; 
                var years = []
                for (var i = currentYear; i <= lastYear; i++) {
                    years.push(i);
                }
                return years;
            },

        },

        methods: {
            toggle_cliente(val) {
                this.campos.es_cliente = val;
                if (this.campos.es_cliente) {
                    this.cambiar_modo('verificacion');
                } else {
                    this.cambiar_modo('formulario');
                }
            },

            verificar_cliente() {
                // verificar en Negocios si existe el cliente
                this.resetear_resultado();
                this.habilitado = false;
                let self = this;
                jQuery.ajax({
                    type: 'POST',
                    url: 'https://sac.bas.com.ar/WebService.asmx/DatosCliente',
                    data: JSON.stringify({
                        codcli: this.campos.codcli,
                        cuitIngresado: this.campos.cuit,
                        rubro: this.campos.rubro,
                        idProducto: this.campos.idsistema
                    }),
                    contentType: 'application/json; charset=utf-8',
                    dataType: 'json',
                    success: function (msg) {
                        log("Datos de cliente verificados");
                        let jsonresult = JSON.parse(msg.d)
                        if (typeof (jsonresult.error) != 'undefined') {
                            self.informar_error(jsonresult.descripcion);
                        } else {
                            self.campos.razon_social = jsonresult.razon_social;
                            self.campos.domicilio = jsonresult.domicilio;
                            self.campos.email = jsonresult.email;                        
                            
                            if (jsonresult.tiene_producto === "True") {
                                self.version_vigente = jsonresult.version_vigente;
                                self.campos.versiones_instaladas = JSON.parse(jsonresult.versiones_instaladas);
                                self.campos.tiene_producto = true;
                                // if (jsonresult.tiene_sar === "True") {
                                //     self.campos.tiene_sar = true;
                                //     self.cambiar_modo('formulario');
                                // } else {
                                //     self.informar_error('Comunícate con nosotros al (011) 5238-7600 para ser atendido por tu Ejecutivo')
                                // }

                                // si está descargando una versión distinta a la vigente, se muestra un aviso debajo del contrato
                                
                                self.cambiar_modo('formulario');
                            } else {
                                self.cambiar_modo('formulario');
                            }
                        }
                    },
                    error: function (jqXHR, textStatus, errorThrown) {
                        log(jqXHR)
                        self.informar_error('No se pudo verificar los datos. ' + errorThrown);
                    },
                    complete: function () {                    
                        self.habilitado = true;
                    }
                });
            },

            verificar_forma_pago () {
                let verifica = true;

                if(this.campos.forma_pago == this.formas_pago.CBU){
                    let res = this.validar_cbu(this.campos.cbu)
                    if (res!=null){
                        verifica  = false; 
                        this.informar_error(res)
                    }
                }
                if(this.campos.forma_pago == this.formas_pago.AUT){
                    let res = this.validar_tarjeta();
                    if (res!=null) {
                        verifica = false;
                        this.informar_error(res);
                    }
                }
                if (verifica){
                    this.cambiar_modo('contrato');
                }

            },

            toggle_forma_pago(val) {
                this.campos.forma_pago = this.formas_pago[val];
                this.campos.forma_pago_cod = val;
            },

            procesar_form(ev) {
                // se dispara en el fieldset formulario
                this.resetear_resultado();
                let validar = this.validar();
                if (validar == null) {
                    this.cambiar_modo('forma_pago');
                } else {
                    this.informar_error(validar);
                }
            },

            cambiar_modo(m) {
                this.resetear_resultado();
                this.modo = m;
                if (this.modo == 'contrato') {
                    this.completar_contrato();
                }
                if (this.modo == 'forma_pago') {
                    this.campos.tarjeta.titular = this.nombre_completo;
                }
                jQuery('body,html').animate({
                    scrollTop: jQuery("#app").offset().top
                }, 800);
                // document.getElementById("app").scrollIntoView({
                //     behavior: 'smooth'
                // });
                return false;
            },

            cambiar_pack(p) {
                this.campos.pack = p;
            },

            completar_contrato() {
                this.contrato = 'Un momento por favor...';
                let self = this;
                var data = {
                    action: 'render_contrato',
                    datos: self.campos,
                    _ajax_nonce: jQuery('#solicitud_email_ajax_nonce').data('nonce')
                };
                jQuery.ajax({
                    type: 'POST',
                    url: `${server()}/wp-admin/admin-ajax.php`,
                    data: data
                })
                .done(function (msg) {
                    self.contrato = (msg);
                })
                .fail(function (jqXHR, textStatus, errorThrown) {
                    log(jqXHR, errorThrown);
                    self.resultado = errorThrown + " " + textStatus;
                })
                .always(function () {
                });
            },

            enviar_emails() {
                this.habilitado = false;
                this.resetear_resultado();
                let self = this;
                var data = {
                    action: 'mail_before_submit_licencia',
                    datos: self.campos,
                    // _ajax_nonce: jQuery('#solicitud_email_ajax_nonce').data('nonce')
                };

                jQuery.ajax({
                    type: 'POST',
                    url: `${server()}/wp-admin/admin-ajax.php`,
                    data: data
                })
                .done(function (msg) {
                    if (self.parametros.debug){
                        log(msg);
                    }
                    self.finalizar();
                })
                .fail(function (jqXHR, textStatus, errorThrown) {
                    log(jqXHR, errorThrown);
                    self.resultado = errorThrown + " " + textStatus;
                })
                .always(function () {
                    self.habilitado = true;
                });
            },

            finalizar() {
                this.habilitado = true;
                this.cambiar_modo('gracias');
            },

            validar() {
                var respuesta = null;
                if (this.campos.es_cliente && this.campos.codcli == null) {
                    respuesta = "Completar el Código de cliente"
                }
                if (this.campos.nombre.trim() == "") {
                    respuesta = "Completar el Nombre"
                }
                if (this.campos.apellido.trim() == "") {
                    respuesta = "Completar el Apellido"
                }
                if (this.campos.email.trim() == "") {
                    respuesta = "Completar el Email"
                }
                if (this.campos.telefono.trim() == "") {
                    respuesta = "Completar el Teléfono"
                }
                if (this.campos.dni.trim() == "") {
                    respuesta = "Completar el DNI"
                }
                if (this.campos.cargo.trim() == "") {
                    respuesta = "Completar el Cargo"
                }
                if (this.campos.razon_social.trim() == "") {
                    respuesta = "Completar el Titular/Razón Social"
                }
                if (this.campos.cuit.trim() == "") {
                    respuesta = "Completar el CUIT/DNI"
                }
                if (this.campos.domicilio.trim() == "") {
                    respuesta = "Completar el Domicilio Fiscal"
                }
                var re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                if (!re.test(this.campos.email)) {
                    respuesta = "El Email no es válido"
                }
                if (this.campos.quiere_adicionales){
                    if( this.campos.adicionales=="") {
                        respuesta = "Indicar la cantidad de "  + this.campos.adicionales_tipo
                    }
                    if (this.campos.adicionales>15){
                        respuesta = "La cantidad máxima permitida de " + this.campos.adicionales_tipo + " es de 15"
                    }
                    if (this.campos.adicionales <= 0) {
                        respuesta = "La cantidad mínima permitida de " + this.campos.adicionales_tipo + " es de 1"
                    }

                } 
                return respuesta;
            },

            validar_tarjeta(){
                let respuesta = null;
                if (this.campos.tarjeta.numero == null || this.campos.tarjeta.numero =="") {
                    respuesta = "Completar el número de la tarjeta de crédito"
                }
                if (this.campos.tarjeta.titular == null || this.campos.tarjeta.titular =="") {
                    respuesta = "Completar el titular de la tarjeta de crédito"
                }
                if (this.campos.tarjeta.tarjeta == null) {
                    respuesta = "Seleccionar una tarjeta de crédito"
                }
                if(this.nro_tarjeta_valido==false){
                    respuesta = "El número de tarjeta no se verifica como uno válido"
                }
                let fecha = new Date()
                
                if(fecha.setFullYear(this.campos.tarjeta.vto_anio, this.campos.tarjeta.vto_mes, 1) < (new Date())){
                    respuesta = "La fecha de vencimiento de la tarjeta expiró"
                }
                return respuesta;
            },

            validar_cbu(cbu){
                let respuesta = null;
                let check = !isNaN(parseFloat(cbu)) && isFinite(cbu);
                if (!check || cbu<0) {
                    respuesta = "La CBU debe tener sólo dígitos";
                }
                if (cbu.length != 22){
                    respuesta = "La CBU debe tener 22 dígitos";
                }
                return respuesta;
            },

            informar_error(txt) {
                alertify.alert(txt);
                log(txt)
                this.habilitado = true;
            },

            resetear_resultado() {
                this.resultado = null;
                this.resultado_modo = null;
            },

            home() {
                this.resetear_resultado();
                this.cambiar_modo('inicio');
            },

            rango_cantidad(event) {
                var value = Number(event.target.value)
                
                if (value > 50) {
                    this.campos.cantidad = 50;
                } else if (value <= 0 || Number.isNaN(value)) {
                    this.campos.cantidad = 1;
                } else {
                    this.campos.cantidad = value;
                }
            },

            test_referer(){
                // para testear el envio a admin-ajax.php
                let self = this;
                var data = {
                    action: 'test_referer',
                    datos: self.campos,
                    // _ajax_nonce: jQuery('#solicitud_email_ajax_nonce').data('nonce')
                };
                jQuery.ajax({
                    type: 'POST',
                    url: `${server()}/wp-admin/admin-ajax.php`,
                    data: data,
                    contentType: 'application/x-www-form-urlencoded',
                    // dataType: 'json',
                    success: function (msg) {
                        log(msg);                    
                    },
                    error: function (jqXHR, textStatus, errorThrown) {
                        log(jqXHR, errorThrown);
                    },
                    complete: function () {
                        log("complete")
                    }
                });            
            },

        },

        
        mounted() {
            
            alertify.defaults.transition = 'fade';
            alertify.defaults.glossary.title = "Revisa los siguientes datos"
            alertify.defaults.glossary.ok = "Aceptar";
            
            if (this.parametros.debug) {
                // this.cambiar_modo('forma_pago');
                this.campos = {
                    grupo: 'clientes',
                    tipo: this.parametros.tipo_licenciamiento,
                    titulo: null,                
                    sistema: this.parametros.sistema,
                    rubro: this.parametros.rubro,
                    idsistema: this.parametros.idsistema,
                    pack: this.parametros.pack,
                    cantidad: 1,
                    quiere_adicionales: false, // exclusivo PACK5 
                    adicionales: "",
                    adicionales_tipo: "",
                    nombre: 'Pedro',
                    apellido: 'López',
                    email: 'esteban@lombardinet.com',
                    telefono: '011 4444-1111',
                    dni: "99888777",
                    cargo: "Programador",
                    razon_social: 'Mi Empresa S.A.',
                    tipo_documento: 'cuit',
                    cuit: '27220923598', //'30-51542474-8', //
                    domicilio: 'Domicilio',
                    iibb: '11-2223445-0',
                    es_cliente: false,
                    forma_pago: 'Débito automático Cuenta Bancaria',
                    forma_pago_cod: 'CBU',
                    cbu: '1234567890123456789012',
                    tarjeta: {
                        titular: 'Mi nombre',
                        tarjeta: 'Visa',
                        numero: '4509111111111111',
                        vto_mes: new Date().getMonth() + 1,
                        vto_anio: new Date().getFullYear()
                    },
                    // cbu: null,
                    // tarjeta: {
                    //     titular: 'Mi nombre',
                    //     tarjeta: 'Visa',
                    //     numero: null,
                    //     vto_mes: new Date().getMonth() + 1,
                    //     vto_anio: new Date().getFullYear()
                    // },
                    versiones_instaladas: null,
                    codcli: '29', //'1142' //
                    tiene_sar: false
                }
            }
            

            if (this.parametros.tipo_licenciamiento == 'software') { 
                this.acepta_label = 'Acepto los Términos y Condiciones Convenio de Licencia de Uso de Software.'
                this.campos.titulo = "SOLICITUD DE LICENCIA TEMPORAL DE SOFTWARE";
                this.campos.adicionales_tipo = "Accesos Adicionales"
            }
            if (this.parametros.tipo_licenciamiento == 'saas') { 
                this.acepta_label = 'Acepto los Términos y Condiciones de Easy Soft SAAS y del Convenio de Licencia de Uso de Software.'
                this.campos.titulo = "SOLICITUD DE SERVICIO EASY SOFT SAAS";
                this.campos.adicionales_tipo = "Usuarios Adicionales"
            }

        },

    }
</script>


<style lang="scss">

    @import "@/assets/scss/form.scss";
    
    .tarjeta {
        width: 100px;
        height: 40px;
        background-size: cover;
        text-indent: -9999px;
        cursor: pointer;
        display: inline-block;
        vertical-align: middle;

        &.visa {
            background-image: url('./../assets/img/logos_visa.svg');
        }

        &.master {
            background-image: url('./../assets/img/logos_master.svg');

        }
    }
</style>